import {

    GET_CITY_DEFINITIONS_SUCCESS,
    ADD_CITY_DEFINITION_SUCCESS,
    UPDATE_CITY_DEFINITION_SUCCESS,
    DELETE_CITY_DEFINITION_SUCCESS,
    API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  }
  
  const cityDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_CITY_DEFINITIONS_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
          error: {}
        }
  
      case ADD_CITY_DEFINITION_SUCCESS:
        return {
          ...state,
          recordList: [...state.recordList, action.payload],
          error: {}
        }
  
      case UPDATE_CITY_DEFINITION_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.map(record =>
            record.guid.toString() === action.payload.guid.toString()
              ? { record, ...action.payload }
              : record
          ),
          error: {}
        }
  
      case DELETE_CITY_DEFINITION_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
          error: {}
        }
  
      case API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default cityDefinition